// Outaback Tread theme JS

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.product-form');
  if (!form) return;

  const variantSelect = form.querySelector('#VariantId');
  const stockEl = document.getElementById('ProductStock');
  const qtyInput = document.getElementById('Quantity');
  const addBtn = form.querySelector('.product-add');

  if (!stockEl || !qtyInput || !addBtn) return;

  const overallStock = parseInt(stockEl.dataset.overallStock || '0', 10) || 0;

  function updateStockAndQuantity() {
    let stock = overallStock;

    if (variantSelect && variantSelect.options.length) {
      const opt = variantSelect.options[variantSelect.selectedIndex];
      const ds = opt && opt.getAttribute('data-stock');
      if (ds !== null && ds !== '') {
        const v = parseInt(ds, 10);
        if (!isNaN(v)) stock = v;
      }
    }

    if (!Number.isFinite(stock)) stock = 0;

    if (stock <= 0) {
      stockEl.textContent = 'Back soon';
      addBtn.disabled = true;
      addBtn.textContent = 'Back soon';
      qtyInput.value = 1;
      qtyInput.max = 1;
    } else {
      stockEl.textContent = 'In stock: ' + stock;

      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';

      // Cap per-order qty to 5, but never above stock
      const maxAllowed = stock > 5 ? 5 : stock;
      qtyInput.max = maxAllowed;
      if (parseInt(qtyInput.value, 10) > maxAllowed || !qtyInput.value) {
        qtyInput.value = maxAllowed > 0 ? maxAllowed : 1;
      }
    }
  }

  updateStockAndQuantity();

  if (variantSelect) {
    variantSelect.addEventListener('change', updateStockAndQuantity);
  }
});
